import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { financeApi, LedgerResponse } from '../../services/financeApi';

export interface FinanceLedgerFilters {
    customerId?: number;
    fromDate?: string;
    toDate?: string;
}

interface FinanceLedgerState {
    summary: LedgerResponse['data'] | null;
    customers: LedgerResponse['customers'];
    filters: FinanceLedgerFilters;
    loading: boolean;
    error: string | null;
}

const initialState: FinanceLedgerState = {
    summary: null,
    customers: [],
    filters: {},
    loading: false,
    error: null,
};

export const fetchFinanceLedger = createAsyncThunk(
    'financeLedger/fetch',
    async (filters: FinanceLedgerFilters = {}) => {
        return await financeApi.getLedger(filters);
    }
);

const financeLedgerSlice = createSlice({
    name: 'financeLedger',
    initialState,
    reducers: {
        setFinanceLedgerFilters: (state, action: PayloadAction<FinanceLedgerFilters>) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        clearFinanceLedger: (state) => {
            state.summary = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFinanceLedger.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFinanceLedger.fulfilled, (state, action: PayloadAction<LedgerResponse>) => {
                state.loading = false;
                state.summary = action.payload.data;
                state.customers = action.payload.customers;
            })
            .addCase(fetchFinanceLedger.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load ledger';
            });
    },
});

export const { setFinanceLedgerFilters, clearFinanceLedger } = financeLedgerSlice.actions;
export default financeLedgerSlice.reducer;

